import React from 'react';
import { doctorInfo } from '../data/mock';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 px-4 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-800 rounded-full text-sm font-semibold">
              Medical Oncologist & Cancer Care Expert
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              {doctorInfo.name}
            </h1>
            <p className="text-xl text-gray-600">
              {doctorInfo.credentials}
            </p>
            <p className="text-lg text-gray-700 font-medium">
              {doctorInfo.currentPosition}
            </p>
            
            {/* Leadership Roles - Prominently displayed */}
            <div className="bg-gradient-to-r from-teal-700 to-teal-600 rounded-xl p-6 text-white space-y-3">
              <h3 className="text-sm font-semibold uppercase tracking-wide opacity-90">Leadership Positions</h3>
              {doctorInfo.leadershipRoles.map((role) => (
                <div key={role} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-white rounded-full mt-2"></div>
                  <p className="text-base font-medium">{role}</p>
                </div>
              ))}
            </div>

            <p className="text-lg text-gray-600 leading-relaxed">
              {doctorInfo.tagline}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button onClick={scrollToContact} size="lg" className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-6 text-lg">
                Book Consultation
              </Button>
              <Button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })} variant="outline" size="lg" className="border-teal-700 text-teal-700 hover:bg-teal-50 px-8 py-6 text-lg">
                Learn More
              </Button>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={doctorInfo.photo}
                alt={doctorInfo.name}
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <div className="text-white">
                  <p className="text-2xl font-bold">112+</p>
                  <p className="text-sm">Published Research Papers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-6 h-6 text-teal-700" />
      </div>
    </section>
  );
};

export default Hero;